module.exports = __webpack_public_path__ + "img/e0a94ff8d0fea7e21d1e1a71bc8c78e7.jpg";